var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "cel_navigation", class: { open: _vm.naviOpen } },
    [
      _vm._m(0),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "closes",
          class: { open: _vm.naviOpen },
          attrs: { id: "celerart-navigation_nav-icon2" },
          on: {
            click: function($event) {
              _vm.naviOpen = !_vm.naviOpen
            }
          }
        },
        [
          _c("span"),
          _vm._v(" "),
          _c("span"),
          _vm._v(" "),
          _c("span"),
          _vm._v(" "),
          _c("span"),
          _vm._v(" "),
          _c("span"),
          _vm._v(" "),
          _c("span")
        ]
      ),
      _vm._v(" "),
      _c(
        "ul",
        {
          staticClass: "celerart-navigation_nav",
          class: { open: _vm.naviOpen }
        },
        [
          _c(
            "li",
            { staticClass: "celerart-navigation_nav-item" },
            [
              _c("router-link", { attrs: { to: { name: "HomeNew" } } }, [
                _vm._v("\n                    HomeNew\n                ")
              ])
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "li",
            { staticClass: "celerart-navigation_nav-item" },
            [
              _c("router-link", { attrs: { to: { name: "OfferListNew" } } }, [
                _vm._v("\n                    OfferListNew\n                ")
              ])
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "li",
            { staticClass: "celerart-navigation_nav-item" },
            [
              _c("router-link", { attrs: { to: { name: "checkoutNew" } } }, [
                _vm._v("\n                    checkoutNew\n                ")
              ])
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "li",
            { staticClass: "celerart-navigation_nav-item" },
            [
              _c("router-link", { attrs: { to: { name: "RateNew" } } }, [
                _vm._v("\n                    RateNew\n                ")
              ])
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "li",
            { staticClass: "celerart-navigation_nav-item" },
            [
              _c("router-link", { attrs: { to: { name: "PriceOutdate" } } }, [
                _vm._v("\n                    PriceOutdate\n                ")
              ])
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "li",
            { staticClass: "celerart-navigation_nav-item" },
            [
              _c(
                "router-link",
                { attrs: { to: { name: "InstructionPage" } } },
                [
                  _vm._v(
                    "\n                    InstructionPage\n                "
                  )
                ]
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "li",
            { staticClass: "celerart-navigation_nav-item" },
            [
              _c("router-link", { attrs: { to: { name: "AffiliatePage" } } }, [
                _vm._v("\n                    AffiliatePage\n                ")
              ])
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "li",
            { staticClass: "celerart-navigation_nav-item" },
            [
              _c("router-link", { attrs: { to: { name: "Landing" } } }, [
                _vm._v("\n                    Landing\n                ")
              ])
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "li",
            { staticClass: "celerart-navigation_nav-item" },
            [
              _c("router-link", { attrs: { to: { name: "TemplateList" } } }, [
                _vm._v("\n                    TemplateList\n                ")
              ])
            ],
            1
          ),
          _vm._v(" "),
          _c("li", { staticClass: "celerart-navigation_nav-item" }, [
            _c(
              "button",
              {
                staticClass: "btn btn-gray small",
                on: {
                  click: function($event) {
                    _vm.old = !_vm.old
                  }
                }
              },
              [_vm._v("open old")]
            )
          ]),
          _vm._v(" "),
          _c("transition", { attrs: { name: "fade" } }, [
            _vm.old
              ? _c("li", { staticClass: "celerart-navigation_nav-item" }, [
                  _c("ul", [
                    _c(
                      "li",
                      { staticClass: "celerart-navigation_nav-item" },
                      [
                        _c(
                          "router-link",
                          { attrs: { to: { name: "index" } } },
                          [
                            _vm._v(
                              "\n                                Index\n                            "
                            )
                          ]
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "li",
                      { staticClass: "celerart-navigation_nav-item" },
                      [
                        _c(
                          "router-link",
                          { attrs: { to: { name: "about" } } },
                          [
                            _vm._v(
                              "\n                                about\n                            "
                            )
                          ]
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "li",
                      { staticClass: "celerart-navigation_nav-item" },
                      [
                        _c(
                          "router-link",
                          { attrs: { to: { name: "companylist" } } },
                          [
                            _vm._v(
                              "\n                                companylist\n                            "
                            )
                          ]
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "li",
                      { staticClass: "celerart-navigation_nav-item" },
                      [
                        _c(
                          "router-link",
                          { attrs: { to: { path: "/company-page/1" } } },
                          [
                            _vm._v(
                              "\n                                companyPage\n                            "
                            )
                          ]
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "li",
                      { staticClass: "celerart-navigation_nav-item" },
                      [
                        _c(
                          "router-link",
                          { attrs: { to: { name: "terms" } } },
                          [
                            _vm._v(
                              "\n                                terms\n                            "
                            )
                          ]
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "li",
                      { staticClass: "celerart-navigation_nav-item" },
                      [
                        _c(
                          "router-link",
                          { attrs: { to: { name: "contact" } } },
                          [
                            _vm._v(
                              "\n                                contact\n                            "
                            )
                          ]
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "li",
                      { staticClass: "celerart-navigation_nav-item" },
                      [
                        _c(
                          "router-link",
                          { attrs: { to: { name: "offer" } } },
                          [
                            _vm._v(
                              "\n                                offer\n                            "
                            )
                          ]
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "li",
                      { staticClass: "celerart-navigation_nav-item" },
                      [
                        _c(
                          "router-link",
                          { attrs: { to: { name: "UserData" } } },
                          [
                            _vm._v(
                              "\n                                UserData\n                            "
                            )
                          ]
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "li",
                      { staticClass: "celerart-navigation_nav-item" },
                      [
                        _c(
                          "router-link",
                          { attrs: { to: { name: "confirm" } } },
                          [
                            _vm._v(
                              "\n                                DataConfirmation\n                            "
                            )
                          ]
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "li",
                      { staticClass: "celerart-navigation_nav-item" },
                      [
                        _c(
                          "router-link",
                          { attrs: { to: { name: "NotFound" } } },
                          [
                            _vm._v(
                              "\n                                NotFound\n                            "
                            )
                          ]
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "li",
                      { staticClass: "celerart-navigation_nav-item" },
                      [
                        _c("router-link", { attrs: { to: { name: "Rate" } } }, [
                          _vm._v(
                            "\n                                Rate\n                            "
                          )
                        ])
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "li",
                      { staticClass: "celerart-navigation_nav-item" },
                      [
                        _c(
                          "router-link",
                          { attrs: { to: { name: "ThankYou" } } },
                          [
                            _vm._v(
                              "\n                                ThankYou\n                            "
                            )
                          ]
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "li",
                      { staticClass: "celerart-navigation_nav-item" },
                      [
                        _c(
                          "router-link",
                          { attrs: { to: { name: "OldBrowser" } } },
                          [
                            _vm._v(
                              "\n                                OldBrowser\n                            "
                            )
                          ]
                        )
                      ],
                      1
                    )
                  ])
                ])
              : _vm._e()
          ])
        ],
        1
      )
    ]
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "celerart-navigation_title" }, [
      _c("p", [_vm._v("Nav")])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }